import { statusColorRenderer } from "../../util/helper/helperFunctions";
import "../../assets/css/LgvPopup/LgvPopup.css";

const renderIconType = (status, nonLGVRotation) =>
  status === "white"
    ? {
        backgroundColor: "white",
        color: "black",
        transform: nonLGVRotation ? "rotate(90deg)" : "none",
      }
    : {
        backgroundColor: statusColorRenderer(status),
      };

const LgvIcon = ({ data, status, className, isFollowing, nonLGVRotation }) => (
  <>
    <span
      style={renderIconType(status, nonLGVRotation)}
      className={className ?? "lgv-icon-style"}
    >
      {data}
    </span>
    {isFollowing && (
      <span id="lgv-wrapper-circle">
        <span className="lgv-wrapper-circle-outer"></span>
        <span className="lgv-wrapper-circle-inner"></span>
      </span>
    )}
  </>
);

export default LgvIcon;
